<template>
    <div class="content">
      <div class="row align-items-center">
        <div class="col-md-2 ms-3" align="left">
          <v-btn fab dark x-small color="primary">
            <router-link :to="`/administrar-clientes`">
              <v-icon dark> arrow_back</v-icon>
            </router-link>
          </v-btn>
        </div>
  
        <div class="col" align="right">
          <div class="col-md-12" align="right">
            <v-btn color="primary" dark @click="openModal()">
              Nuevo
            </v-btn>
          </div>

          <v-dialog v-model="showForm" persistent max-width="800px">
          <v-card>
            <v-card-title>
              <span class="text-h5">
                {{ show ? 'Datos Split':'Formulario de Split' }}</span
              >
              <v-spacer></v-spacer>
              <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="closeModal()"
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>close</v-icon>
                  </v-btn>
                </template>
              </v-menu>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form ref="form_create" v-model="valid" lazy-validation>
                    <v-row align="center">
                      <v-col cols="12" md="12">
                        <v-text-field
                          v-model="nombre"
                          label="Nombre del Split*"
                          required
                          :disabled="show"
                        ></v-text-field>
                      </v-col>
                    </v-row>                    
                    <v-row align="center" v-if="!show && !edit">
                      <v-col cols="12" md="4">
                        <v-select
                          v-model="select_cliente"
                          :items="clientes"
                          item-text="cliente"
                          item-value="id"
                          label="Cliente*"      
                          :disabled="sumaTotal >= 100"
                          required
                          @change="filtrarCuentas($event)"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-select
                            v-model="selecte_cuenta"
                            :items="cuentas"
                            :disabled="cuentas.length == 0 || sumaTotal >= 100"
                            item-text="cuenta"
                            item-value="id"
                            label="Cuenta*"                            
                            required
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="nuevo_monto"
                          label="Porcentaje"
                          type="number"            
                          :disabled="sumaTotal >= 100"              
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="1">
                        <v-btn fab dark x-small :disabled="sumaTotal >= 100" @click="addCuenta()">
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                </v-form>
                <v-data-table                  
                  :headers="headersSplitComputada"
                  :items="split"
                  :loading="false"
                  :items-per-page="10"
                  hide-default-footer
                  disable-sort
                  loading-text="Cargando... Espere por favor"
                  no-results-text="Debe cargar un split"
                  no-data-text="Debe cargar un split"
                  class="elevation-1 trow"
                  v-if="!edit"
                >                  
                  <template v-slot:no-results>
                    <v-alert color="error" icon="warning">
                      found no results.
                    </v-alert>
                  </template>
                  <!-- ACCIONES BOTONES -->
                  <template v-slot:[`item.id`]="{ item }">
                     {{ item.nombre_cliente }} - {{item.nombre_cuenta}}
                  </template>                  
                  <template v-slot:[`item.porcentaje_cuenta`]="{ item }">
                    {{item.porcentaje_cuenta}}%
                  </template>             
                  <template v-slot:[`item.tipo`]="{ item }">
                    {{item.tipo.toUpperCase()}}
                  </template>             
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip top color="red">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="mr-2"
                          fab
                          dark
                          x-small
                          color="red"
                          @click="quitarDeSplit(item.id)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> mdi-close </v-icon>
                        </v-btn>
                      </template>
                      <span>Quitar</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:footer>
                    <span v-if="sumaTotal > 0 && !show && !edit">Total asignado: {{ sumaTotal }} %</span>
                    <span v-if="sumaTotal > 0 && 100 - sumaTotal > 0 && !show && !edit"> - Total sin asignar: {{ 100 - sumaTotal }} %</span>
                  </template>
                </v-data-table>
              </v-container>              
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="closeModal()"
              >
                Cerrar
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                v-if="!show"
                :loading="loadingModal"
                :disabled="sumaTotal < 100 && !edit"
                @click="edit ? update(): guardar()"
              >
                Guardar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        </div>
      </div>
  
      <LayoutPage :title="'Split de pagos'">
        <v-app>
          <v-main>
            <section v-if="errored">
              <v-alert 
                border="left"
                class="mt-4 mx-3 elevation-3"
                color="red lighten-2"
                dark
              >
                Lo sentimos, no es posible obtener la información en este momento,
                por favor intente nuevamente mas tarde.
              </v-alert>
            </section>
            <v-data-table
              :search="search"
              :headers="headers"
              :items="splitPagos"
              :loading="loadingTabla"
              :items-per-page="itemsPerPage"
              hide-default-footer
              disable-sort
              loading-text="Cargando... Espere por favor"
              no-results-text="No se encontraron registros"
              no-data-text="No se encontraron registros"
              class="elevation-1 trow"
            >
              <template v-slot:no-results>
                <v-alert color="error" icon="warning">
                  found no results.
                </v-alert>
              </template>
              <!-- ACCIONES BOTONES -->
                     
               <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip top color="orange">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="mr-2"
                          fab                          
                          :dark="true"
                          x-small
                          color="orange"
                          @click="openEditModal(item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> mdi-pencil </v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                  <v-tooltip top color="green">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="mr-2"
                          fab                          
                          :dark="true"
                          x-small
                          color="green"
                          @click="openModalComposicion(item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> mdi-eye </v-icon>
                        </v-btn>
                      </template>
                      <span>Ver composición</span>
                    </v-tooltip>
                  <v-tooltip top color="red">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="mr-2"
                          fab                          
                          :dark="true"
                          x-small
                          color="red"
                          @click="eliminarSplit(item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>Eliminar Split</span>
                    </v-tooltip>
               </template>
              <template v-slot:footer>
                <v-row class="no-gutters mt-2 mx-2">
                  <v-flex xs12 class="align-items-center">
                    <span>Mostrar</span>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn dark text color="primary" class="ml-2" v-on="on">
                          {{ rowsPerPage }}
                          <v-icon>arrow_drop_down</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(number, index) in rowsPerPageArray"
                          :key="index"
                          @click="updateRowsPerPage(number)"
                        >
                          <v-list-item-title>{{ number }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-flex>
                </v-row>
              </template>
            </v-data-table>
            <div class="text-center pt-2">
              <v-pagination
                v-model="pagination.page"
                :length="pagination.total"
                :total-visible="pagination.visible"
                @input="onPageChange"
              ></v-pagination>
            </div>
          </v-main>
        </v-app>
      </LayoutPage>
    </div>
  </template>
  
<script>
  import LayoutPage from "../../LayoutPage.vue";
  import splitService from "../../../services/administrar/split";
  import { Clientes } from "../../../services/clientes";
import { computed } from "vue";
  
  export default {
    components: {
      name: "SplitPagos",
      LayoutPage,      
    },
    data: function() {
      return {
        errored: false,
        search: "",
        headers: [
        { text: "Nombre", value: "nombre"},        
        { text: "Acciones", value: "actions" },
        ],
        itemsPerPage: 10,
        pagination: {
          page: 1,
          total: 0,
          visible: 5
        },
        loadingTabla: false,
        rowsPerPageArray: [5, 10, 15, 20],
        rowsPerPage: 10,
        valid: false,
        showForm: false,
        edit: false,
        show: false,
        clientes: [],        
        cuentas: [],
        splitPagos: [],
        
        //Modal
        headersSplit:[
          { text: "Cuenta", value: "id" },
          { text: "Porcentaje", value: "porcentaje_cuenta" },
          { text: "Tipo", value: "tipo" },        
          { text: "Acciones", value: "actions", sortable: false },
        ],
        nombre: '',
        select_cliente: null,
        selecte_cuenta: null,
        nuevo_monto: '',
        split:[],
        sumaTotal: 0,
        loadingModal: false,

        //Modal Composicion        
        itemSelected: [],
      };
    },
    created() {
    //   this.getDatos();
    },
    methods: {
        filtrarCuentas(selected) {                    
            this.cuentas = this.clientes.find(cliente => cliente.id == selected).cuenta.filter(cuenta => !this.split.some(s => s.id === cuenta.id));
        },
        onPageChange() {
            this.page = this.pagination.page;
            this.getSplits();
        },
        updateRowsPerPage(number) {
          this.rowsPerPage = number;
          this.getSplits();
        },
        openModal() {
            this.showForm = true;
        },
        closeModal() {
            this.split = [];            
            this.cuentas = [];
            this.nombre = '';
            this.edit = false;
            this.show = false;
            this.select_cliente = null;
            this.selecte_cuenta = null;
            this.showForm = false;
        },
        openModalComposicion(item) {          
          this.split = item.cuentas.map(c => ({
            id: c.id,
            nombre_cuenta: c.cuenta,
            nombre_cliente: c.cliente,
            porcentaje_cuenta: c.porcentaje.toString(),
            tipo: c.tipo
          }));
          this.nombre = item.nombre;
          this.show = true;
          this.showForm = true;
        },
        openEditModal(item) {                            
          this.nombre = item.nombre;      
          this.split.push({
            id: item.id
          });
          this.edit = true;
          this.showForm = true;
        },
        addCuenta() {     
          this.sumaTotal = 0;    
          this.split.forEach(cuenta => {
            this.sumaTotal += parseFloat(cuenta.porcentaje_cuenta);
          })
          this.sumaTotal += parseFloat(this.nuevo_monto);
          if(this.nuevo_monto == ''){
            this.$toastr.i("El porcentaje debe ser mayor a 0 y solo numeros");
            return;
          }
          if(this.sumaTotal > 100){
            this.sumaTotal -= parseFloat(this.nuevo_monto);
            this.$toastr.i("El porcentaje total no puede superar el 100%");
            return
          }          
          
          const cuentaSeleccionada = this.cuentas.find(c => c.id === this.selecte_cuenta);          
          const clienteSeleccionado = this.clientes.find(c => c.id === this.select_cliente);
          
          if (cuentaSeleccionada && clienteSeleccionado) {
            this.split.push({
              id: cuentaSeleccionada.id,
              nombre_cuenta: cuentaSeleccionada.cuenta,
              nombre_cliente: clienteSeleccionado.cliente,
              porcentaje_cuenta: this.nuevo_monto,
              tipo: this.split.length === 0 ? 'principal' : 'secundaria'
            });
          }

          this.select_cliente = null;
          this.cuentas = [];
          this.selecte_cuenta = null;
          this.nuevo_monto = '';
        },
        quitarDeSplit(id) {          
          const itemAEliminar = this.split.find(cuenta => cuenta.id === id);
          
          if (itemAEliminar && itemAEliminar.tipo === 'principal') {
            const primerSecundaria = this.split.find((cuenta) => cuenta.tipo === 'secundaria');
            if (primerSecundaria) {
              this.split = this.split.map(cuenta => {
                if (cuenta.id === primerSecundaria.id) {
                  return { ...cuenta, tipo: 'principal' };
                }
                return cuenta;
              });
            }
          }             
          this.split = this.split.filter(cuenta => cuenta.id !== id);
          
          this.sumaTotal = this.split.reduce((total, cuenta) => total + parseFloat(cuenta.porcentaje_cuenta || 0), 0);
          this.filtrarCuentas(this.select_cliente);
        },
        getCuentaById(item) {
            return this.cuentas.find(cuenta => cuenta.id === item.id).cuenta;
        },
        async guardar () {
          if(this.nombre == ''){
            this.$toastr.i("El nombre no puede estar vacio");
            return;
          }
          let splitFormateado = {
            nombre: this.nombre,
            cuentas: this.split.map(cuenta => {
              return {
                id: cuenta.id,
                porcentaje: parseFloat(cuenta.porcentaje_cuenta),
                tipo: cuenta.tipo.toUpperCase()
              }
            })
          }
          
          this.storeSPlit(splitFormateado);
          
          this.split = [];
          this.nombre = '';
          this.sumaTotal = 0;
          this.showForm = false;
          
        },
        async update() {
          let body = {
            id: this.split[0].id,
            nombre: this.nombre,            
          }
          this.patchSplit(body);
          this.closeModal();
        },
        async eliminarSplit (item) {
          const { isConfirmed } = await this.$swal.fire({
            title: "¿Esta seguro?",
            text:
              "Esta acción actualizará desactivará el split de pagos.",
            icon: "warning",
            showDenyButton: true,
            confirmButtonText: "Si, continuar",
            denyButtonText: "Cancelar",
          });

          if (isConfirmed) {            
              this.desactivarSplit(item.id);
          }
        },
        getclientes: function() {
            const params = {
                CargarCuentas: true,
                Number: 1,
                Size: 100,
                CuentaSplit: true
            };
            this.cargando = true;
            Clientes.getClientes(params)
                .then((response) => {
                    if (response.data.data == null) {
                        this.clientes = [];
                    } else {
                        this.clientes = response.data.data;
                    }
                })
                .catch((error) => {
                    this.errored = true;
                    var data = error.response.data;
                    this.error = true;
                    this.$toastr.e(data.message);
                })
                .finally(() => (this.cargando = false));
        },
        getSplits: function() {
            const params = {
                number: this.pagination.page,
                size: this.rowsPerPage,
                activo: 1
            };
            this.loadingTabla = true;
            splitService.getSplit(params)
                .then((response) => {
                    if (response.data == null) {
                        this.splitPagos = [];
                    } else {                                            
                        this.splitPagos = response.data.splitpagos;
                        this.pagination.page = response?.data?.meta?.page.currentPage || 1;
                        this.pagination.total = response?.data?.meta?.page.lastPage;
                    }
                })
                .catch((error) => {
                    this.errored = true;
                    var data = error.response.data;
                    this.error = true;
                    this.$toastr.e(data.message);
                })
                .finally(() => (this.loadingTabla = false));
        },
        storeSPlit: function async(body){
          this.loadingModal = true;
            splitService.storeSplit(body)
                .then((response) => {
                    this.$toastr.s(response.message);
                })
                .catch((error) => {
                    // this.errored = true;
                    var data = error.response.data;
                    this.error = true;
                    this.$toastr.e(data.message);
                })
                .finally(() => {
                  this.loadingModal = false;
                  this.getSplits();
                });
        },
        patchSplit: function async(body){
          this.loadingModal = true;
            splitService.editSplit(body)
                .then((response) => {
                    this.$toastr.s(response.message);
                })
                .catch((error) => {
                  this.$toastr.e('Ocurrio un error al actualizar');
                })
                .finally(() => {
                  this.loadingModal = false;
                  this.getSplits();
                });
        },          
        desactivarSplit: function async(id){
          this.loadingModal = true;
            splitService.desactivarSplit(id)
                .then((response) => {
                    this.$toastr.s('Split de pagos desactivado correctamente');
                })
                .catch((error) => {
                    this.errored = true;
                    var data = error.response.data;
                    this.error = true;
                    this.$toastr.e(data.message);
                })
                .finally(() => {
                  this.loadingModal = false;
                  this.getSplits();
                });
        }
    },  
    mounted() {
        this.getclientes();
        this.getSplits();        
        
    },  
    computed: {
      headersSplitComputada () { 
        return this.show ? 
        [
          { text: "Cuenta", value: "id" },
          { text: "Porcentaje", value: "porcentaje_cuenta" },
          { text: "Tipo", value: "tipo" },                 
        ] : [
          { text: "Cuenta", value: "id" },
          { text: "Porcentaje", value: "porcentaje_cuenta" },
          { text: "Tipo", value: "tipo" },        
          { text: "Acciones", value: "actions", sortable: false },
        ]
      }  
    }
  };
</script>
<style scoped> 
    a[data-v-1b84c964] {
      color: #e6f1e3;
    }
    
    .theme--light.v-btn {
      color: rgb(93 175 118 / 87%);
    }
    
    .theme--dark.v-btn.v-btn--has-bg {
      background-color: #50b565;
    }
    .v-dialog > .v-card > .v-card__text {
      padding-bottom: 0px;
    }
</style>
  